import React from "react";
import styled from "styled-components";
import { AiOutlineClockCircle } from "react-icons/ai";
import { Divider } from "../ProfileComponents";
import { FaCoins, FaSmoking, FaUsers } from "react-icons/fa";

const Filters = ({
  handleSort,
  sortBy,
  handleDeparturetime,
  departureTime,
  amenity,
  handleAmenity,
  clearAll,
  page = "somepage",
}) => {
  return (
    <FilterWrapper page={page}>
      <div className="filter-items">
        <div className="header">
          <h3>Sort by</h3>
          <p className="link clear" onClick={clearAll}>
            Clear All
          </p>
        </div>
        <div className="item" onClick={(e) => handleSort("earliest")}>
          <span
            className={sortBy === "earliest" ? "active-text" : ""}
          >
            <AiOutlineClockCircle />
            <span>Earliest departure</span>
          </span>
          <span>
            <input
              type="radio"
              value="earliest"
              checked={sortBy === "earliest"}
              readOnly
            />
          </span>
        </div>
        <div className="item" onClick={(e) => handleSort("price")}>
          <span className={sortBy === "price" ? "active-text" : ""}>
            <FaCoins />
            <span>Lowest price</span>
          </span>
          <span>
            <input type="radio" value="price" checked={sortBy === "price"} readOnly />
          </span>
        </div>
        <Divider>
          <hr />
        </Divider>
        <h3>Departure Time</h3>

        <div className="item" onClick={(e) => handleDeparturetime("bf6")}>
          <span
             className={departureTime === "bf6" ? "active-text" : ""}
          >
            <span>Before 06:00</span>
          </span>
          <span>
            <input type="radio" value="bf6" checked={departureTime === "bf6"} readOnly />
          </span>
        </div>
        <div className="item" onClick={(e) => handleDeparturetime("6-12")}>
          <span
            className={departureTime === "6-12" ? "active-text" : ""}
          >
            <span>06:00 - 12:00</span>
          </span>
          <span>
            <input
              type="radio"
              value="6-12"
              checked={departureTime === "6-12"}
              readOnly
            />
          </span>
        </div>
        <div className="item" onClick={(e) => handleDeparturetime("12-18")}>
          <span
            className={departureTime === "12-18" ? "active-text" : ""}
          >
            <span>12:01 - 18:00</span>
          </span>
          <span>
            <input
              type="radio"
              value="12-18"
              checked={departureTime === "12-18"}
              readOnly
            />
          </span>
        </div>
        <div className="item" onClick={(e) => handleDeparturetime("after6Pm")}>
          <span
            className={departureTime === "after6Pm" ? "active-text" : ""}
          >
            <span>After 18:00</span>
          </span>
          <span>
            <input
              type="radio"
              value="after6Pm"
              checked={departureTime === "after6Pm"}
              readOnly
            />
          </span>
        </div>
        <Divider>
          <hr />
        </Divider>
        <h3>Amenities</h3>
        <div className="item" onClick={(e) => handleAmenity("2inB")}>
          <span className={amenity === "2inB" ? "active-text" : ""}>
            <FaUsers />
            <span>Max. 2 in back</span>
          </span>
          <span>
            <input
              type="radio"
              value="2inB"
              checked={amenity === "2inB"}
              readOnly
            />
          </span>
        </div>
        <div className="item" onClick={(e) => handleAmenity("smoking")}>
          <span
            className={amenity === "smoking" ? "active-text" : ""}
          >
            <FaSmoking />
            <span>Smoking allowed</span>
          </span>
          <span>
            <input
              type="radio"
              value="smoking"
              checked={amenity === "smoking"}
              readOnly
            />
          </span>
        </div>
      </div>
    </FilterWrapper>
  );
};

export default Filters;

const FilterWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: flex-start;
  width: 100%;

  .filter-items {
    display: flex;
    flex-direction: column;
    gap: ${(props) => (props.page === "carpool" ? "0.75rem" : "0.8rem")};
    width: 100%;
    color: #475569; /* Slate 600 */

    h3 {
      font-size: 0.95rem;
      font-weight: 700;
      color: #054752; /* Primary Teal */
      margin-bottom: 0.25rem;
    }

    .header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 0.5rem;

      .clear {
        cursor: pointer;
        font-size: 0.8rem;
        color: #ef4444;
        font-weight: 600;
        &:hover {
          text-decoration: underline;
        }
      }
    }

    .item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      gap: 1rem;
      cursor: pointer;
      padding: 0.4rem 0.5rem;
      border-radius: 6px;
      transition: background 0.2s ease;
      min-width: ${(props) => (props.page === "carpool" ? "unset" : "190px")};

      &:hover {
        background: #f1f5f9;
        color: #054752;
      }

      span {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        font-size: 0.9rem;
        
        &.active-text {
          font-weight: 700;
          color: #054752;
        }
      }

      input[type="radio"] {
        accent-color: #054752;
        cursor: pointer;
        width: 16px;
        height: 16px;
      }
    }
    
    hr {
      border-color: #e2e8f0;
    }
  }
`;
